import * as React from 'react';

interface NestedExpandAllState {
  anyRowExpanded: boolean;
  hasExpandableRows: boolean;
  onExpandAll: () => void;
  onCollapseAll: () => void;
}

/** Set only when the table shows Expand all, so the expander column's header can offer it. */
export const NestedExpandAllContext = React.createContext<NestedExpandAllState | null>(null);
